import angular from 'angular';
class RealtimeJoinTracker {
    constructor($timeout, $rootScope, $log) {
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$log = $log;
        this.PRESENCE_JOIN_DELAY = 3000;
        this.joinTracker = {};
        window.debugJoinDublication = {};
    }
    startTrackJoin(channel, uid) {
        window.debugJoinDublication[channel + uid] = {
            start: new Date().getTime(),
        };
        this.$log.debug('RealtimeJoinTracker:startTrackJoin', channel, uid);
        this.joinTracker[channel] = this.joinTracker[channel] || {};
        this.joinTracker[channel][uid] = this.$timeout(() => {
            this.$rootScope.$emit('realtime:presence:join-fail', { channel, uid });
            this.joinTracker[channel][uid] = null;
            this.$log.debug('RealtimeJoinTracker:realtime:presence:join-fail', channel, uid);
        }, this.PRESENCE_JOIN_DELAY);
    }
    stopTrackJoin(channel, uid) {
        this.$log.debug('RealtimeJoinTracker:stopTrackJoin', channel, uid);
        if (window.debugJoinDublication &&
            window.debugJoinDublication[channel + uid]) {
            const data = window.debugJoinDublication[channel + uid];
            data.stop = new Date().getTime();
            data.duration = data.stop - data.start;
        }
        if (this.joinTracker[channel] && this.joinTracker[channel][uid]) {
            this.$timeout.cancel(this.joinTracker[channel][uid]);
            this.joinTracker[channel][uid] = null;
        }
    }
}
export default angular
    .module('doxy.realtime.common.services.realtimeJoinTracker', [])
    .service('realtimeJoinTracker', RealtimeJoinTracker).name;
